import { removeItem } from 'actions/CheckoutActions'
import { navigateToCheckout } from 'checkout/actions/navigateActions'
import IconButton from 'components/Luxkit/Button/IconButton'
import TextButton from 'components/Luxkit/Button/TextButton'
import DropdownChevron from 'components/Luxkit/Dropdown/DropdownChevron'
import DropdownContainer from 'components/Luxkit/Dropdown/DropdownContainer'
import Dropdown from 'components/Luxkit/Dropdown/Dropdown'
import LineShoppingCartIcon from 'components/Luxkit/Icons/line/LineShoppingCartIcon'
import LineTrashIcon from 'components/Luxkit/Icons/line/LineTrashIcon'
import ListItem from 'components/Luxkit/List/ListItem'
import { useAppDispatch } from 'hooks/reduxHooks'
import useToggle from 'hooks/useToggle'
import { rem } from 'polished'
import React, { useCallback, useRef } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import CartModeModal from 'components/Common/Modals/AddToCartModal/AddToCartModal'
import { checkoutCartItemViews } from 'selectors/checkoutCartSelectors'
import { useCheckoutFlightJourney } from 'checkout/hooks/useCheckoutFlightData'

const BottomButton = styled(TextButton)`
  margin-top: ${rem(20)};
`

const MenuItem = styled.div`
  position: relative;
`

const StyledDropdownContainer = styled(DropdownContainer)`
  color: ${({ theme }) => theme.palette.neutral.two};
  text-align: left;
`

const StyledDropdownButton = styled(TextButton)`
  padding-right: ${rem(4)};
`

const CartItemNumber = styled.div`
  display: inline-block;
  margin-left: ${rem(8)};
  width: ${rem(20)};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.neutral.one};
  color: ${({ theme }) => theme.palette.neutral.eight};
`

interface MappedProps {
  itemViews: App.Checkout.CartItemView[];
}

function MyCartMenu({
  itemViews,
}: MappedProps) {
  const { value: menuOpen, toggle: onToggle, off: onClose } = useToggle()
  const triggerRef = useRef(null)
  const dispatch = useAppDispatch()

  useCheckoutFlightJourney()

  const onRemove = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    dispatch(removeItem(e.currentTarget.id))
  }, [dispatch])

  const onNavigateClick = useCallback(() => {
    dispatch(navigateToCheckout({ skipSpoofedModal: true }))
  }, [dispatch])

  return <MenuItem>
    <StyledDropdownButton
      kind="primary"
      variant="ghost"
      startIcon={<LineShoppingCartIcon/>}
      endIcon={<DropdownChevron open={menuOpen}/>}
      ref={triggerRef}
      onClick={onToggle}
    >
      My Cart
      {itemViews.length > 0 && <CartItemNumber>{itemViews.length}</CartItemNumber>}
    </StyledDropdownButton>
    <Dropdown
      open={menuOpen}
      onClose={onClose}
      triggerRef={triggerRef}
    >
      <StyledDropdownContainer
        title="Cart"
        subtitle={`${itemViews.length} cart items`}
      >
        {itemViews.length > 0 && <>
          {itemViews.map(item => (
            <ListItem
              size="medium"
              key={item.id}
              title={item.label}
              subtitle={item.subtitle}
              children={<IconButton id={item.id} kind="tertiary" onClick={onRemove}>
                <LineTrashIcon/>
              </IconButton>}
            />
          ))}
          <BottomButton kind="primary" fit="full-width" onClick={onNavigateClick}>
            Go to checkout
          </BottomButton>
        </>}
      </StyledDropdownContainer>
    </Dropdown>
    <CartModeModal/>
  </MenuItem>
}

function mapStateToProps(state: App.State) {
  return {
    itemViews: checkoutCartItemViews(state),
  }
}

export default connect(mapStateToProps)(MyCartMenu)
